// extracted by mini-css-extract-plugin
module.exports = {"validationRule":"validationRule--tBdvr"};